/**
 * Viewport breakpoint constants matching Tailwind's default breakpoints
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

/**
 * Helper function to check if the current viewport width is mobile-sized
 * @param breakpoint - The max width in pixels to consider as mobile (default: 1024px for lg breakpoint)
 * @returns boolean indicating if the viewport is mobile-sized
 */
export const checkIsMobile = (breakpoint: number = BREAKPOINTS.lg): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.innerWidth < breakpoint;
};

/**
 * Helper function to get the current viewport width
 * @returns The current viewport width in pixels
 */
export const getViewportWidth = (): number => {
  if (typeof window === "undefined") {
    return 0;
  }
  return window.innerWidth;
};

/**
 * Helper function to get the current viewport height
 * @returns The current viewport height in pixels
 */
export const getViewportHeight = (): number => {
  if (typeof window === "undefined") {
    return 0;
  }
  return window.innerHeight;
};
